export default "__VITE_ASSET___VfAi4eG__"